/**
 * Event triggered to close the tutorial tip.
 * @type {string} - The event name.
 */
export const TRIGGER_CLOSE_TUTORIAL_TIP_EVENT = 'trigger-close-tutorial-tip';

/**
 * Event triggered to trigger the next tutorial tip.
 * @type {string} - The event name.
 */
export const TRIGGER_NEXT_TUTORIAL_TIP_EVENT = 'trigger-next-tutorial-tip';

/**
 * Event triggered to trigger the close widgets tip.
 * @type {string} - The event name.
 */
export const TRIGGER_CLOSE_WIDGETS_TIP_EVENT = 'trigger-close-widgets-tip';
